import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import tag from "../images/icons8-tag-100.png";
import steeringwheel from "../images/icons8-steering-wheel-100.png";
import greet from "../images/icons8-handshake-100.png";
import airportimg from "../images/airport_transfer_new2.jpg";
import { db } from '../../firebase-config';
import { collection, getDocs, query, where } from 'firebase/firestore';
import CircularProgress from "@mui/material/CircularProgress";
import Mapboxpage from "../Mapboxpage";

const AirportTransfers = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  const [Airporttransfersservices, AirporttransfersServices] = useState([]);
  const headerData = Airporttransfersservices[0];
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);

        const q = query(
          collection(db, "ownerPageDatas"),
          where("selectedmenutype", "==", "Airporttransfers")
        );

        const querySnapshot = await getDocs(q);

        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        AirporttransfersServices(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false); // ✅ important
      }
    };

    fetchServices();
  }, []);


  // 👇 Loader here
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress size={60} sx={{ color: "#45B2F7" }} />
      </div>
    );
  }


  return (
    <>
      <div
        className="mainhero-container"
        style={{
          backgroundImage: `url(${headerData?.headerimage || airportimg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
      
        }}
      >
        <div className="mainhero-content">
          <h1>
            <span style={{ color: "#45B2F7" }}>
              {headerData?.headerTitle?.split(" ")[0] || "Luxury"}
            </span>{" "}
            {headerData?.headerTitle?.split(" ").slice(1).join(" ") || "Airport Transfers Service"}
          </h1>
          <p>
            {headerData?.headerDescription || "Enjoy professional and seamless airport transfers.."}

          </p>
        </div>

        <Mapboxpage />
      </div>
      <br />

      {/* INFO CARDS */}
      <div className="cards-containerairport">
        <div className="info-card">
          <div className="card-text">
            <img src={tag} alt="service" className="card-logo" />
            <br />
            <h3>Transparent Airport Transfer Pricing</h3>

            <p>
              MAS Mobility Services offers fixed and transparent airport
              transfer pricing with no hidden charges or last-minute surprises.
              Our all-inclusive fares are confirmed during booking, ensuring a
              smooth and stress-free travel experience.
            </p>
          </div>
        </div>

        <div className="info-card">
          <div className="card-text">
            <img
              src={steeringwheel}
              alt="service"
              className="card-logo"
            />
            <br />
            <h3>Experienced Professional Chauffeurs</h3>

            <p>
              Travel comfortably with MAS Mobility Services’ trained and
              professional chauffeurs who prioritize your safety,
              punctuality, and comfort.
            </p>
          </div>
        </div>

        <div className="info-card">
          <div className="card-text">
            <img src={greet} alt="service" className="card-logo" />
            <br />
            <h3>Premium Meet & Greet Assistance</h3>

            <p>
              Skip long taxi queues with MAS Mobility Services’ airport
              meet & greet service. Our chauffeurs welcome you inside the
              terminal and assist with luggage handling.
            </p>
          </div>
        </div>
      </div>

      <br />

      {/* SERVICES SECTION */}

      <div>
        {loading ? (
          <div className="skeleton-card">loading ....</div>
        ) : Airporttransfersservices?.length === 0 ? (
          <h2 style={{ textAlign: "center" }}>No data found</h2>
        ) : (
          Airporttransfersservices?.map((service, index) => (
            <div
              key={service.id}
              className={`service-section ${index % 2 !== 0 ? "reverse" : ""
                }`}
            >
              {/* IMAGE */}
              <div
                className="service-image"
                data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
              >
                <img src={service.image} alt={service.description} />
              </div>

              {/* CONTENT */}
              <div className="service-content">
                <h2>{service.description}</h2>

                <ul className="service-list">
                  {service?.content
                    ?.split(".")
                    .filter((item) => item.trim() !== "")
                    .map((item, index) => (
                      <li key={index}>
                        {item.trim()}
                      </li>
                    ))}
                </ul>
              </div>

            </div>
          ))
        )}
      </div>


    </>
  );
};

export default AirportTransfers;